<template>
    <header>
        <div class="d-flex align-items-center justify-content-between bg-tertiary-gradient p-4">
            <div class="app-logo">
                <router-link
                    v-if="authenticatedLogoUrl"
                    :to="authenticatedLogoUrl"
                >
                    <SVGSprite
                        :inherit-fill="false"
                        name="logo"
                        class="app-logo__icon"
                    />
                    <SVGSprite
                        :inherit-fill="false"
                        name="logo-red"
                        class="app-logo__icon app-logo__icon--print"
                    />
                </router-link>
                <a
                    v-else
                    href="http://moeawp.tdrstaging.co.uk/"
                >
                    <SVGSprite
                        :inherit-fill="false"
                        name="logo"
                        class="app-logo__icon"
                    />
                    <SVGSprite
                        :inherit-fill="false"
                        name="logo-red"
                        class="app-logo__icon app-logo__icon--print"
                    />
                </a>
            </div>
            <div
                v-if="authenticated"
                class="d-flex align-items-center"
            >
                <ul class="header-items d-flex align-items-center list-unstyled mb-0">
                    <li
                        v-for="item in header"
                        :key="item.id"
                    >
                        <router-link
                            :to="{ name: item.id }"
                            :class="[ 'header-item--' + item.id ]"
                            class="header-item"
                        >
                            <SVGSprite
                                v-if="item.icon"
                                :name="item.icon"
                                class="header-item__icon"
                            />
                            <span
                                v-if="item.count"
                                class="item-alert"
                            >
                                {{ item.count }}
                            </span>
                        </router-link>
                    </li>
                </ul>
                <a
                    v-if="authenticated"
                    href="#"
                    class="header-burger d-inline-block d-md-none ml-4"
                    @click.prevent="toggleSidebar()"
                >
                    <SVGSprite
                        name="menu"
                        class="header-burger__icon"
                    />
                </a>
            </div>
        </div>
    </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import common from 'js/mixins/common';

export default {
    name: 'Header',
    mixins: [
        common
    ],
    computed: {
        ...mapState('user', ['authenticated', 'user']),
        ...mapGetters('user', ['notificationCounts']),
        header() {
            return [
                {
                    id: 'notifications',
                    title: 'Notifications',
                    icon: 'bell',
                    count: this.notificationCounts.alerts
                },
                {
                    id: 'messages',
                    title: 'Messages',
                    icon: 'messages',
                    count: this.notificationCounts.messages
                },
                {
                    id: 'my-profile',
                    title: 'My Profile',
                    icon: 'my-profile',
                    count: this.notificationCounts.account
                }
            ];
        },
        authenticatedLogoUrl() {
            return this.authenticated && {
                name: 'dashboard'
            };
        }
    },
    methods: {
        toggleSidebar() {
            this.$root.$emit('headerToggleSidebar');
        }
    }
};
</script>

<style lang="scss">
.header {
    background-color: #ffffff;
}

.app-logo {
    a {
        display: inline-block;
    }

    &__icon {
        max-width: 14rem;

        @media print {
            &.svg-sprite {
                display: none;
            }
        }

        &--print {
            &.svg-sprite {
                display: none;
            }

            @media print {
                &.svg-sprite {
                    display: inline-block;
                }
            }
        }

        @include media-breakpoint-up(md) {
            max-width: 22rem;
        }
    }
}

.header-items {
    margin-left: -5px;
    margin-right: -5px;

    li {
        padding-left: 5px;
        padding-right: 5px;
    }
}

.header-item {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: theme-color('tertiary-hover');
    line-height: 0;
    position: relative;
    transition: all .3s ease;

    .svg-sprite {
        width: 1.5rem;
        color: theme-color('tertiary-hover');

        @include media-breakpoint-up(md) {
            width: 2rem;
        }
    }

    @include media-breakpoint-up(md) {
        width: 40px;
        height: 40px;
    }

    @include media-breakpoint-up(lg) {
        &:hover {
            background: theme-color('secondary');

            .svg-sprite {
                color: white;
            }
        }
    }
}

// Sidebar toggle
.header-burger {
    line-height: normal;
    background: transparent;

    &__icon {
        width: 2.5rem;
        color: white;
    }
}
</style>
